
// Export data as CSV
export const exportCSV = (data: any[], filename: string) => {
  if (!data || data.length === 0) return;
  
  // Convert data to CSV format
  const keys = Object.keys(data[0]);
  const csvHeader = keys.join(',');
  const csvRows = data.map(row => 
    keys.map(key => {
      const value = row[key];
      return typeof value === 'string' ? `"${value}"` : value;
    }).join(',')
  );
  const csvContent = [csvHeader, ...csvRows].join('\n');
  
  // Create download link
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Date range options
export const DATE_RANGES = [
  { name: 'Last 24 Hours', value: 1 },
  { name: 'Last 7 Days', value: 7 },
  { name: 'Last 30 Days', value: 30 },
  { name: 'Last 90 Days', value: 90 }
];

// Colors for charts
export const COLORS = [
  '#4f46e5', '#3b82f6', '#06b6d4', '#10b981', 
  '#84cc16', '#eab308', '#f97316', '#ef4444',
  '#ec4899', '#8b5cf6', '#a855f7', '#d946ef'
];

// Referrer category labels for display
export const REFERRER_CATEGORY_LABELS = {
  'direct': 'Direct Access',
  'search_engine': 'Search Engines',
  'social_media': 'Social Media',
  'academic': 'Academic Sites',
  'news_blog': 'News & Blogs',
  'other_website': 'Other Websites',
  'email': 'Email',
  'unknown': 'Unknown'
};

// UTM parameter labels
export const UTM_LABELS = {
  'utm_source': 'Campaign Source',
  'utm_medium': 'Campaign Medium',
  'utm_campaign': 'Campaign Name',
  'utm_content': 'Campaign Content'
};

// Helper function to format referrer source for display
export const formatReferrerSource = (category: string, source?: string): string => {
  if (category === 'direct') {
    return 'Direct Access';
  } else if (category === 'search_engine' && source) {
    return `${source.charAt(0).toUpperCase() + source.slice(1)} Search`;
  } else if (category === 'social_media' && source) {
    switch (source) {
      case 'twitter':
      case 'x':
        return 'X (Twitter)';
      case 'linkedin':
        return 'LinkedIn';
      case 'facebook':
        return 'Facebook';
      case 'reddit':
        return 'Reddit';
      case 'discord':
        return 'Discord';
      default:
        return `${source.charAt(0).toUpperCase() + source.slice(1)}`;
    }
  } else if (category === 'academic' && source) {
    if (source === 'academic_institution') {
      return 'Academic Institutions';
    } else {
      return `${source.charAt(0).toUpperCase() + source.slice(1)}`;
    }
  } else if (category === 'news_blog' && source) {
    return `${source.charAt(0).toUpperCase() + source.slice(1)}`;
  } else if (category === 'email') {
    return 'Email';
  } else if (category === 'other_website') {
    if (source) {
      // Display the actual domain for other websites
      return source;
    } else {
      return 'Other Websites';
    }
  } else {
    // Fallback to category name
    return category.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
};
